export const GET_ERRORS = 'GET_ERRORS';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';

export const SET_USERS_LOADING = 'SET_USERS_LOADING'
export const SET_USERS = 'SET_USERS'

export const SET_APPROVE_CONTENTS = 'SET_APPROVE_CONTENTS'
export const SET_CONTENTS = 'SET_CONTENTS'
export const SET_NEXT_CONTENTS = 'SET_NEXT_CONTENTS'
export const SET_CONTENTS_LOADING = 'SET_CONTENTS_LOADING'
export const SET_APPROVE_CONTENT = 'SET_APPROVE_CONTENT'

export const SET_ROLL_CALL_LOADING = 'SET_ROLL_CALL_LOADING'
export const SET_ROLL_CALL = 'SET_ROLL_CALL'
export const UPDATE_NEW_ROLL_CALL = 'UPDATE_NEW_ROLL_CALL'
export const UPDATE_CURRENT_ROLL_CALL = "UPDATE_CURRENT_ROLL_CALL"


// WEBPACK FOOTER //
// ./src/actions/types.js